module.exports = __webpack_public_path__ + "img/4.fef8a8ff.png";